/* Rider Kit — Build Your Kit cart upsell (category-driven, fluid).
   Discount code + gift code are read per-widget from data attributes (data-rk-code / data-rk-giftcode),
   so the same JS drives every category. Optimistic UI + background sync + debounced re-render.
*/
(function () {
  if (window.__riderKitInit) return;
  window.__riderKitInit = true;

  var chain = Promise.resolve();
  var rerenderTimer = null;
  var lastCodes = null;
  var pending = 0; // in-flight cart ops; only re-render when this hits 0 (avoids racing rapid clicks)

  // Anti-abuse: the 5 gift variants RIDERKITGIFTS zeroes. The 100%-off code has no native
  // quantity cap, so the cart +/- stepper (or a manual add) could turn "3 free perks" into
  // unlimited free gear. We clamp every gift line to qty 1 and the kit to MAX_GIFTS distinct.
  var GIFT_VARS = ['46658197422241', '46658198929569', '46658199158945', '46658199322785', '46658199617697', '46717737238689'];
  var MAX_GIFTS = 3;
  var sanitizing = false;

  function rootUrl() { return (window.Shopify && Shopify.routes && Shopify.routes.root) || '/'; }
  function cartUpdateUrl() { return (window.routes && window.routes.cart_update_url) || (rootUrl() + 'cart/update.js'); }
  function post(url, body) {
    return fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) });
  }
  function num(v) { return parseFloat(v) || 0; }
  function bump(el) { el.classList.remove('rk-bump'); void el.offsetWidth; el.classList.add('rk-bump'); }

  function repaint(r) {
    var cards = r.querySelectorAll('.rk-card');
    var onCards = r.querySelectorAll('.rk-card.rk-on');
    var picks = onCards.length, cost = 0, value = 0;
    [].forEach.call(onCards, function (c) { cost += num(c.getAttribute('data-rk-cost')); value += num(c.getAttribute('data-rk-value')); });
    var max = parseInt(r.getAttribute('data-rk-max') || '3', 10);
    var cap = num(r.getAttribute('data-rk-cap')) || 100;
    var giftOn = r.querySelectorAll('.rk-card[data-rk-type="gift"].rk-on').length;
    var itemMax = max + 1; // the $70 + rk_max gift = the "max 2 items" cap
    var full = giftOn >= max; // gift limit reached — dims the OTHER gifts (never the $70)
    var complete = picks >= itemMax; // both the $70 and the gift are locked in

    r.classList.toggle('rk--full', full);
    var cnt = r.querySelector('[data-rk-count]'); if (cnt) cnt.textContent = picks + ' / ' + itemMax;
    var pill = r.querySelector('.rk__pill'); if (pill) pill.classList.toggle('rk__pill--full', complete);

    [].forEach.call(cards, function (c) {
      if (c.classList.contains('rk-on')) { c.classList.remove('rk-card--locked'); return; }
      if (c.getAttribute('data-rk-type') === 'discount') { c.classList.remove('rk-card--locked'); return; } // $70 is a separate perk — never locked
      var tc = num(c.getAttribute('data-rk-cost'));
      c.classList.toggle('rk-card--locked', full || (cost + tc > cap + 0.001));
    });

    var sum = r.querySelector('[data-rk-summary]');
    if (sum) {
      if (picks === 0) sum.innerHTML = 'Save $70 &amp; pick ' + max + ' free gift — your kit, your way';
      else if (complete) sum.innerHTML = '✅ All locked in — $' + value + ' in gear, yours FREE';
      else sum.innerHTML = picks + ' of ' + itemMax + ' selected · pick ' + (itemMax - picks) + ' more';
    }
  }

  function ours(r) {
    return [(r.getAttribute('data-rk-code') || '').toUpperCase(), (r.getAttribute('data-rk-giftcode') || 'RIDERKITGIFTS').toUpperCase()];
  }
  // Build the desired discount string for the current widget state (preserve any non-ours codes).
  function applyCodes(r, discountOn, giftCount) {
    var DC = r.getAttribute('data-rk-code') || '';
    var mine = ours(r); // still strips a stray RIDERKITGIFTS from the slot (gifts are $0 products now)
    var codes = [];
    (r.getAttribute('data-rk-codes') || '').split(',').forEach(function (c) {
      c = c.trim(); if (c && mine.indexOf(c.toUpperCase()) === -1) codes.push(c);
    });
    // Gifts are $0 mock products now (no discount code) — only the −$70 lives in the single code slot.
    if (discountOn) codes.push(DC);
    var str = codes.join(',');
    if (str === lastCodes) return Promise.resolve();
    lastCodes = str;
    return post(cartUpdateUrl(), { discount: str });
  }

  function onCartPage() { return /\/cart\/?$/.test(window.location.pathname); }
  // Reliable re-render for BOTH the cart drawer and the cart page: fetch the current surface's
  // section (Section Rendering API) and swap its content. The theme's own live-render is flaky here.
  function refresh(r) {
    if (rerenderTimer) clearTimeout(rerenderTimer);
    rerenderTimer = setTimeout(function () {
      if (pending > 0) return; // ops still in flight — the last one settling will call refresh again
      lastCodes = null;
      var host = r && r.closest('[render-section]');           // drawer-cart (cart-drawer) OR cart-page (main-cart)
      var sid = host && host.getAttribute('render-section');
      var wrap = host && host.closest('[id^="shopify-section"]');
      if (!sid) {
        try { if (window._EVENT_HELPER && _EVENT_HELPER.updateAndShowCart) document.dispatchEvent(new CustomEvent(_EVENT_HELPER.updateAndShowCart, { detail: {} })); } catch (e) {}
        return;
      }
      fetch(window.location.pathname + '?section_id=' + sid, { headers: { Accept: 'text/html' } })
        .then(function (res) { return res.ok ? res.text() : Promise.reject(); })
        .then(function (html) {
          if (!html || html.length < 80) { if (onCartPage()) window.location.reload(); return; }
          if (sid === 'cart-drawer') {
            // swap only the drawer content so the open drawer stays open
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var fresh = doc.querySelector('[render-section="cart-drawer"]');
            var cur = document.querySelector('[render-section="cart-drawer"]');
            if (fresh && cur) cur.innerHTML = fresh.innerHTML;
          } else if (wrap) {
            wrap.innerHTML = html; // page: swap the whole section (items + widget + totals)
          }
        })
        .catch(function () { if (onCartPage()) window.location.reload(); });
    }, 150); // was 500 — snappier cart update; the POST already resolved, so this only batches rapid clicks
  }

  // Clamp gifts: each gift line -> qty 1, and at most MAX_GIFTS distinct gift lines (extras removed).
  function sanitizeGifts() {
    if (sanitizing) return;
    sanitizing = true;
    fetch(rootUrl() + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        // A qualifying bike = a NON-gift line that IS a bike (product_type) — no price gate (Bruno 2026-07-19); >= $1000 kept as fallback.
        // Gifts are only free as a reward for a bike, so with no bike in the cart we remove them —
        // this kills the "add a bike, grab the free gifts, then remove the bike" exploit.
        var hasBike = (cart.items || []).some(function (it) {
          return GIFT_VARS.indexOf(String(it.variant_id)) === -1 && (['Road Bike','Gravel Bike','Mountain Bike','eMTB'].indexOf(it.product_type) !== -1 || it.original_price >= 100000);
        });
        var rootEl = document.querySelector('[data-rk-root]');
        var maxKeep = rootEl ? (parseInt(rootEl.getAttribute('data-rk-max') || '3', 10) || MAX_GIFTS) : MAX_GIFTS;
        var updates = {}, kept = 0, changed = false;
        (cart.items || []).forEach(function (it) {
          if (GIFT_VARS.indexOf(String(it.variant_id)) === -1) return;
          if (!hasBike) { updates[it.variant_id] = 0; changed = true; return; } // no bike -> gift can't be free -> remove
          if (kept < maxKeep) {
            kept++;
            if (it.quantity > 1) { updates[it.variant_id] = 1; changed = true; }
          } else { updates[it.variant_id] = 0; changed = true; } // 4th+ gift -> remove
        });
        if (!changed) { sanitizing = false; return; }
        return post(cartUpdateUrl(), { updates: updates }).then(function () {
          sanitizing = false;
          var r = document.querySelector('[data-rk-root]');
          if (r) refresh(r);
        });
      })
      .catch(function () { sanitizing = false; });
  }

  // ── CHECKOUT GATE (Bruno 2026-08-14): mata a corrida "removeu a bike e clicou
  // CHECKOUT antes da limpeza terminar" — a única janela que ainda deixava brinde
  // órfão virar pedido $0. Intercepta o clique em QUALQUER botão de checkout
  // (página do carrinho E gaveta), confere o carrinho na hora, remove brindes sem
  // bike e: se sobrou compra de verdade segue pro checkout; se só havia brinde,
  // volta pro carrinho honesto (vazio). Custo: ~200ms no clique. ──
  var gateBusy = false;
  function orphanGiftUpdates(cart) {
    var hasBike = (cart.items || []).some(function (it) {
      return GIFT_VARS.indexOf(String(it.variant_id)) === -1 && (['Road Bike', 'Gravel Bike', 'Mountain Bike', 'eMTB'].indexOf(it.product_type) !== -1 || it.original_price >= 100000);
    });
    if (hasBike) return null;
    var updates = null;
    (cart.items || []).forEach(function (it) {
      if (GIFT_VARS.indexOf(String(it.variant_id)) === -1) return;
      (updates = updates || {})[it.variant_id] = 0;
    });
    return updates;
  }
  document.addEventListener('click', function (e) {
    var el = e.target.closest && e.target.closest('button[name="checkout"], input[name="checkout"], a[href*="/checkout"]');
    if (!el || gateBusy) return;
    e.preventDefault();
    e.stopPropagation();
    gateBusy = true;
    fetch(rootUrl() + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var up = orphanGiftUpdates(cart);
        if (!up) return { segue: true };
        return post(cartUpdateUrl(), { updates: up }).then(function () {
          // sobrou algo que não é brinde? segue; carrinho virou pó? volta pro cart
          var resto = (cart.items || []).some(function (it) { return !(it.variant_id in up); });
          return { segue: resto };
        });
      })
      .catch(function () { return { segue: true }; }) // na dúvida nunca trava a compra
      .then(function (r) {
        if (r && r.segue) { el.click(); setTimeout(function () { gateBusy = false; }, 2500); }
        else { window.location.href = rootUrl() + 'cart'; }
      });
  }, true);

  // Any cart mutation (our widget, the native +/- stepper, a manual add) re-triggers the clamp.
  (function () {
    var _f = window.fetch;
    window.fetch = function (url) {
      var out = _f.apply(this, arguments);
      try {
        var u = (typeof url === 'string') ? url : (url && url.url) || '';
        if (/\/cart\/(change|add|update)\.js/.test(u) && !sanitizing) {
          out.then(function () { setTimeout(sanitizeGifts, 60); }).catch(function () {});
        }
      } catch (e) {}
      return out;
    };
    document.addEventListener('DOMContentLoaded', function () { setTimeout(sanitizeGifts, 300); });
  })();

  document.addEventListener('click', function (e) {
    var perk = e.target.closest && e.target.closest('[data-rk-perk]');
    if (!perk) return;
    var r = perk.closest('[data-rk-root]');
    if (!r) return;
    e.preventDefault();

    var isOn = perk.classList.contains('rk-on');
    if (!isOn && perk.classList.contains('rk-card--locked')) { bump(perk); return; }

    // optimistic
    perk.classList.toggle('rk-on');
    repaint(r);

    var type = perk.getAttribute('data-rk-type');
    var discountCard = r.querySelector('[data-rk-type="discount"]');
    var discountOn = discountCard ? discountCard.classList.contains('rk-on') : false;
    var giftCount = r.querySelectorAll('.rk-card[data-rk-type="gift"].rk-on').length;

    pending++;
    var done = function () { if (pending > 0) pending--; if (pending === 0) refresh(r); };
    chain = chain.then(function () {
      if (type === 'gift') {
        var v = perk.getAttribute('data-rk-variant');
        var nowOn = perk.classList.contains('rk-on');
        // Idempotent: SET this gift's qty to exactly 1 (on) or 0 (off) — never increments,
        // so a double-click / re-render race can't push the line to quantity 2.
        var upd = {}; upd[v] = nowOn ? 1 : 0;
        var op = post(rootUrl() + 'cart/update.js', { updates: upd });
        return op.then(function (res) { if (!res.ok) throw new Error('cart'); return applyCodes(r, discountOn, giftCount); });
      }
      return applyCodes(r, discountOn, giftCount);
    }).then(done, done); // only the LAST settling op (pending===0) triggers the re-render
  });
})();
